import {SourcingVehicleListItemResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

export function getSourcingVehicleId(
  vehicle: SourcingVehicleListItemResponseBody | Nullish
): string | undefined {
  return vehicle?.sourcingVehicle.adId;
}
